import React from 'react';
import { i18n } from '../../../common/services/globalize';
import { Badge } from 'react-bootstrap';

const CalendarEvent = ({ event }) => {
	return (
		<span>
			{event.title}
			{event.availability === 'LastSpot' && <Badge bsStyle='error'>{i18n.t('FO_Booking_Availability_LastSpot')}</Badge>}
		</span>
	);
};

export default CalendarEvent;